import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  SchoolAccessSettings,
  SchoolAccessSettingsRequest,
} from '../entities/school-access-settings.model';

/**
 * `/AccessSettings` (SchoolService) — per-tenant access-control flags for the
 * school gate. `GET` returns the tenant's flags (creating the row with service
 * defaults on first read); `PUT` patches only the provided fields and echoes
 * the full updated record.
 */
@Injectable({ providedIn: 'root' })
export class SchoolAccessSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<SchoolAccessSettings> {
    return this.http.get<SchoolAccessSettings>(`${this.baseUrl}/AccessSettings`, {
      withCredentials: true,
    });
  }

  public update(body: SchoolAccessSettingsRequest): Observable<SchoolAccessSettings> {
    return this.http.put<SchoolAccessSettings>(`${this.baseUrl}/AccessSettings`, body, {
      withCredentials: true,
    });
  }
}
